import Cookie from "js-cookie";

export const SetCookie=(name,value,days)=>{
Cookie.set(name,value,{expires:days});
}


export const getCookie=(name)=>{
return Cookie.get(name);
}

export const deleteCookie=(name)=>{
    return Cookie.remove(name);
}

// Guest purchases aren't tied to an account (id_user = 0) and the auth-only
// /my-tickets endpoint can't return them, so we stash the just-purchased
// stubs in localStorage. This lets the My Tickets page surface a guest's
// tickets in the Upcoming tab after the success modal closes / on reload.
// NOTE: stored barcode/flyer URLs are short-lived signed S3 URLs (~1h TTL);
// after that the images fall back to placeholders but the ticket info stays.
const GUEST_TICKETS_KEY = "_aps_guest_tickets";

export const getGuestTickets = () => {
  try {
    const raw = localStorage.getItem(GUEST_TICKETS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const appendGuestTickets = (stubs) => {
  if (!Array.isArray(stubs) || stubs.length === 0) return;
  try {
    const byKey = new Map();
    [...getGuestTickets(), ...stubs].forEach((s) => {
      const key = s?.id ?? s?.confirmation_id;
      if (key != null) byKey.set(key, s);
    });
    localStorage.setItem(GUEST_TICKETS_KEY, JSON.stringify(Array.from(byKey.values())));
  } catch (e) {
    // Ignore quota / serialization errors — this is a best-effort cache.
  }
};

// Drop the guest cache once a real account takes over (login/register), so it
// doesn't linger alongside the account's own tickets fetched from the API.
export const clearGuestTickets = () => {
  try {
    localStorage.removeItem(GUEST_TICKETS_KEY);
  } catch (e) {
    // no-op
  }
};

export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };


  export const eventListName=[
    "All","This Weekend","Next Weekend"
]



